import { Box, StepIconProps, SvgIcon } from '@mui/material'
import Step from '@mui/material/Step'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import React from 'react'

const steps = ['Email', 'Profile', 'Logo', 'Locations', 'Phone number']

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 41,
    left: 'calc(-50% + 30px)',
    right: 'calc(50% + 30px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#F8B22F',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#F8B22F',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#B3B3B3',
    borderTopWidth: 1,
    borderRadius: 1,
  },
}))

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#B3B3B3',
  display: 'flex',
  height: 80,
  alignItems: 'center',
  textAlign: 'center',
  ...(ownerState.active && {
    color: '#F8B22F',
  }),
  '& .QontoStepIcon-completedIcon': {
    width: 40,
    height: 40,
    borderRadius: '50%',
    borderStyle: 'dashed',
    borderWidth: '1px',
    backgroundColor: 'white',
    borderColor: '#F8B22F',
    color: '#6A707E',
  },
  '& .QontoStepIcon-circleActive': {
    width: 46,
    height: 46,
    backgroundColor: '#F8B22F',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#C8860A',
    color: 'white',
    position: 'relative',
  },
  '& .QontoStepIcon-circleActive:before': {
    position: 'absolute',
    left: -23,
    top: -23,
    width: 60,
    height: 60,
    content: '""',
    display: 'block',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '16px',
    borderColor: 'white',
    zIndex: 1,
  },
  '& .QontoStepIcon-circleActive:after': {
    position: 'absolute',
    left: -16,
    top: -16,
    width: 72,
    height: 72,
    content: '""',
    display: 'block',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '3px',
    borderColor: '#F8B22F',
    zIndex: 1,
  },
  '& .QontoStepIcon-circle': {
    width: 40,
    height: 40,
    borderRadius: '50%',
    borderStyle: 'dashed',
    borderWidth: '1px',
    backgroundColor: 'white',
  },
}))

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className, icon } = props

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <div className="QontoStepIcon-completedIcon">
          <Typography variant="body2" sx={{ lineHeight: '40px', fontSize: '24px', fontWeight: 600 }}>
            {icon}
          </Typography>
        </div>
      ) : active ? (
        <div className="QontoStepIcon-circleActive">
          <Typography variant="body2" sx={{ lineHeight: '46px', fontSize: '30px', fontWeight: 600 }}>
            {icon}
          </Typography>
        </div>
      ) : (
        <div className="QontoStepIcon-circle">
          <Typography variant="body2" sx={{ lineHeight: '40px', fontSize: '24px', fontWeight: 600 }}>
            {icon}
          </Typography>
        </div>
      )}
    </QontoStepIconRoot>
  )
}

export default function OnboardStepper(props) {
  const { activeStep } = props
  return (
    <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
      {steps.map((label, index) => {
        const stepProps: { completed?: boolean } = {}
        return (
          <Step key={label} {...stepProps}>
            <StepLabel StepIconComponent={QontoStepIcon} />
          </Step>
        )
      })}
    </Stepper>
  )
}
